import { StatusBadge } from "@/components/common/StatusBadge";
import { RoleBadge } from "@/components/common/RoleBadge";
import { fmtDate, fmtDateTime, fmtCurrency, fmtNumber, fmtPercent, get } from "@/lib/format";
import { Check, X } from "lucide-react";

export function renderCell(row, col) {
  const raw = get(row, col.key);
  switch (col.type) {
    case "date":
      return <span className="text-stone-700">{fmtDate(raw)}</span>;
    case "datetime":
      return <span className="text-stone-700">{fmtDateTime(raw)}</span>;
    case "currency":
      return <span className="font-mono tabular-nums text-stone-800">{fmtCurrency(raw)}</span>;
    case "number":
      return <span className="font-mono tabular-nums text-stone-800">{fmtNumber(raw)}</span>;
    case "percent":
      return <span className="font-mono tabular-nums text-stone-800">{fmtPercent(raw)}</span>;
    case "mono":
      return raw ? (
        <span className="font-mono text-xs font-semibold text-amber-900 bg-amber-50 px-1.5 py-0.5 rounded border border-amber-200/80">
          {raw}
        </span>
      ) : (
        <span className="text-muted-foreground">—</span>
      );
    case "badge":
      if (col.key === "role" || col.key === "actorRole") return <RoleBadge role={raw} />;
      return <StatusBadge value={raw} />;
    case "bool":
      return raw ? (
        <span className="inline-flex items-center gap-1 text-emerald-700 text-xs font-medium">
          <Check className="h-3.5 w-3.5" /> Yes
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 text-stone-400 text-xs font-medium">
          <X className="h-3.5 w-3.5" /> No
        </span>
      );
    default:
      if (raw === null || raw === undefined || raw === "") return <span className="text-muted-foreground">—</span>;
      if (typeof raw === "object") return <span className="text-muted-foreground italic">[…]</span>;
      return <span className="text-stone-800">{String(raw)}</span>;
  }
}
